import { render, staticRenderFns } from "./RecommendsTable.vue?vue&type=template&id=7dae566c&scoped=true&"
import script from "./RecommendsTable.vue?vue&type=script&lang=ts&"
export * from "./RecommendsTable.vue?vue&type=script&lang=ts&"
import style0 from "./RecommendsTable.vue?vue&type=style&index=0&id=7dae566c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dae566c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
